import React, { PropTypes, Component } from 'react'
import { Colors, Fonts, Metrics } from '../../Themes'
import styled from 'styled-components'
import List from '../List'
import Arrow from '../../svg-icons/Arrow'
import ListItem from '../ListItem'
import Tag from '../Tag'
import CloseIcon from '../../svg-icons/CloseIcon'
import Checkbox from '../../components/Checkbox'

const Header = styled.div`margin: ${Metrics.margins.small} 0;`

const DropdownContainer = styled.div`
  max-width: ${props => (props.width ? props.width : '265px')};
  height: auto;
  border: ${Metrics.borders.default};
  border-radius: ${Metrics.borders.defaultRadius};
  cursor: pointer;
  background: ${Colors.white};
  position: relative;
  outline: none;

  .placeholder {
    ${Fonts.style.Text};
    padding: ${Metrics.margins.small} 0;
    width: 100%;
  }

  .top-container {
    margin-right: ${Metrics.margins.small};
    margin-left: ${Metrics.margins.small};
    text-align: left;
  }

  .list {
    height: inherit;
    margin: 0 ${Metrics.margins.small} ${Metrics.margins.small}
      ${Metrics.margins.small};
  }

  @media screen and (max-width: 768px) {
    width: 100%;

    .placeholder {
      margin-right: ${Metrics.margins.small};
    }
  }
`
const Tags = styled.div`
  margin-top: ${Metrics.margins.tiny};
  height: auto;
  margin-bottom: ${Metrics.margins.small};
  text-align: left;
`

const ArrowIcon = styled.div`
  position: absolute;
  top: 3px;
  right: ${Metrics.margins.small};
  transform: ${props => (props.visible ? 'rotate(0deg)' : 'rotate(180deg)')};
`

const CustomListItem = styled(ListItem)`padding-left: 0;`

const CustomCheckbox = styled(Checkbox)`
  transform: scale(0.7);
  margin-right: ${Metrics.margins.medium};
`

const ItemContainer = styled.div`
  svg {
    float: right;
  }
`

const Item = styled.span`vertical-align: -2px;`

class CheckboxDropdown extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      selectAllChecked: false,
      itemsChecked: {}
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this)
    this.handleItemClick = this.handleItemClick.bind(this)
    this.handleTagClose = this.handleTagClose.bind(this)
  }

  componentWillReceiveProps (nextProps) {
    const { options } = this.props

    if (options.length === 0 && nextProps.options.length > 0) {
      this.setState({
        itemsChecked: nextProps.options.reduce((itemsChecked, option) => {
          itemsChecked[option.id] = false
          return itemsChecked
        }, this.state.itemsChecked)
      })
    }
  }

  handleClick () {
    this.setState({ open: !this.state.open })
  }

  handleSelectAllClick ({ options, handleSelectAll }) {
    const check = !this.state.selectAllChecked

    const itemsChecked = options.reduce((items, item) => {
      items[item.id] = check
      return items
    }, this.state.itemsChecked)

    const selectedOptions = check ? options : []

    this.setState({ selectAllChecked: check, itemsChecked }, () =>
      handleSelectAll(selectedOptions)
    )
  }

  handleItemClick ({ item, handleSelect }) {
    const { itemsChecked } = this.state
    const check = !itemsChecked[item.id]

    this.setState(
      {
        selectAllChecked: false,
        itemsChecked: { ...itemsChecked, [item.id]: check }
      },
      () => handleSelect(item)
    )
  }

  handleTagClose ({ tag, handleSelect }) {
    const { itemsChecked } = this.state

    this.setState(
      {
        selectAllChecked: false,
        itemsChecked: { ...itemsChecked, [tag.id]: false }
      },
      () => handleSelect(tag)
    )
  }

  renderOptions ({ options, showCheckBox, handleSelect }) {
    const { itemsChecked } = this.state

    return options.map((item, index) => {
      return (
        <CustomListItem
          odd={index % 2 === 0}
          key={index}
          onClick={() => this.handleItemClick({ item, handleSelect })}>
          {showCheckBox ? (
            <ItemContainer>
              <CustomCheckbox
                checked={itemsChecked[item.id]}
                id={`interestsCheckBoxId-${index}`}
                className='checkbox'
              />
              <Item>{item.name}</Item>
            </ItemContainer>
          ) : (
            <ItemContainer>
              <Item>{item.name}</Item>
            </ItemContainer>
          )}
        </CustomListItem>
      )
    })
  }

  renderTags ({ selectedOptions, handleSelect }) {
    return selectedOptions.map((el, index) => {
      return (
        <Tag
          key={`Tag-${el.name}-index`}
          text={el.name}
          icon={
            <CloseIcon
              onClick={() => this.handleTagClose({ tag: el, handleSelect })}
            />
          }
        />
      )
    })
  }

  render () {
    const { open, selectAllChecked } = this.state
    const {
      showSelectAll,
      showCheckBox,
      placeholder,
      options,
      handleSelect,
      handleSelectAll,
      selectedOptions,
      showTags
    } = this.props

    return (
      <div>
        <DropdownContainer
          {...this.props}
          tabIndex='-1'
          onBlur={open && this.handleClick}>
          <div className={'top-container'} onClick={this.handleClick}>
            <ArrowIcon visible={this.state.open}>
              <Arrow />
            </ArrowIcon>
            <div className='placeholder'>{placeholder}</div>
          </div>
          <List className={'list'} hide={!this.state.open}>
            {showSelectAll ? (
              <Header
                onClick={() =>
                  this.handleSelectAllClick({ options, handleSelectAll })}>
                <CustomCheckbox
                  id='interestsCheckBoxId'
                  className='checkbox'
                  checked={selectAllChecked}
                />
                <span>Select All</span>
              </Header>
            ) : null}
            {this.renderOptions({ options, showCheckBox, handleSelect })}
          </List>
        </DropdownContainer>
        <Tags>
          {showTags ? this.renderTags({ selectedOptions, handleSelect }) : null}
        </Tags>
      </div>
    )
  }
}

CheckboxDropdown.propTypes = {
  showSelectAll: PropTypes.any,
  options: PropTypes.array.isRequired,
  selectedOptions: PropTypes.array,
  placeholder: PropTypes.string.isRequired,
  handleSelect: PropTypes.func,
  handleSelectAll: PropTypes.func,
  showTags: PropTypes.bool
}

CheckboxDropdown.defaultProps = {
  showSelectAll: false,
  showCheckBox: false
}

export default CheckboxDropdown



// WEBPACK FOOTER //
// ./src/components/CheckboxDropdown/index.js